// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonFull_button__3adPP","button_text":"ButtonFull_button_text__24YTb","block_loader":"ButtonFull_block_loader__3Q66q","loader":"ButtonFull_loader__2Dtq_"};